import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import { delay } from '../../../Utility/Task/TaskQueue';
import ColorFilter from '../../../Component/ColorFilter';

export class Saturation extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: {
            duration: number;
            startSaturation: number;
            endSaturation: number;
            delay: number;
        }
    ): IterableIterator<number> {
        let colorFilter: ColorFilter = gameObject.getComponent(ColorFilter);
        const tween = this.getTween(colorFilter);

        colorFilter.saturation = meta.startSaturation;

        tween
            .to({ saturation: meta.endSaturation }, meta.duration)
            .easing(Easing.Linear.None);

        if (meta.delay) {
            yield* delay(meta.delay);
        }

        yield* this.startTween(tween);
    }
}
